import styled from "styled-components";

import { theme } from "../../themes/themes";
export const SectionWrapper = styled.div`
  display: grid;
  padding: 0.4rem;
  grid-template-columns: 1fr 1em;
  grid-auto-rows: 1em auto;
  align-items: center;

  label {
    grid-column: 1/3;
    color: rgba(123, 123, 123, 1);
    font-size: 14px;
  }

  input,
  select {
    padding: 0.5em;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.button.primary};
  }

  input::placeholder {
    font-size: 12px;
  }
`;